import { get } from 'lodash';

import { ClassConstructor } from '../globals';

export function getOrDefault<T, V>(obj: T, path: string, defaultValue: V): V {
  return (get(obj, path, defaultValue) ?? defaultValue) as V;
}

/**
 * Checks if the given object is an instance of any of the provided class constructors.
 *
 * @param obj - The object to check.
 * @param types - Class constructors to test against.
 * @returns True if obj is an instance of any type in types, otherwise false.
 */
export function instanceOfAny(obj: any, ...types: ClassConstructor<any>[]): boolean {
  return types.some(type => obj instanceof type);
}
